import {
  cycleDamageNumbers,
  cycleEffects,
  cycleScreenShake,
  settings,
  toggleAutoAim,
  toggleLanguage,
  toggleMovementMode,
  toggleSound,
} from '@/config/settings';
import { setFullscreenPreference } from '@/core/fullscreen';
import { t } from '@/i18n';

export interface SettingsRow {
  label: () => string;
  value: () => string;
  /** dir: +1 next value (Space/A/tap/→), -1 previous (←). Toggles ignore it. */
  change: (dir: 1 | -1) => void;
}

const onOff = (on: boolean): string => t(on ? 'settings.on' : 'settings.off');

/** Settings screen rows, in display order (docs/06). */
export const SETTINGS_ROWS: readonly SettingsRow[] = [
  {
    label: () => t('settings.movement'),
    value: () => t(settings.movementMode === 'world' ? 'settings.movement.world' : 'settings.movement.nose'),
    change: toggleMovementMode,
  },
  {
    label: () => t('settings.autoaim'),
    value: () => onOff(settings.autoAim),
    change: toggleAutoAim,
  },
  {
    label: () => t('settings.dmgNumbers'),
    value: () => t(`settings.dmgNumbers.${settings.damageNumbers}`),
    change: cycleDamageNumbers,
  },
  {
    label: () => t('settings.shake'),
    value: () => t(`settings.shake.${settings.screenShake}`),
    change: cycleScreenShake,
  },
  {
    label: () => t('settings.effects'),
    value: () => t(`settings.effects.${settings.effects}`),
    change: cycleEffects,
  },
  {
    label: () => t('settings.sound'),
    value: () => onOff(settings.sound),
    change: toggleSound,
  },
  {
    label: () => t('settings.fullscreen'),
    value: () => onOff(settings.fullscreen),
    change: () => setFullscreenPreference(!settings.fullscreen),
  },
  {
    label: () => t('settings.language'),
    value: () => (settings.language === 'tr' ? 'Türkçe' : 'English'),
    change: toggleLanguage,
  },
];
